export class Handler {
    public boot(): void {}
    public onPop(): void {}

    public onTimeoutOnOff?(): void {}
    public onMenu?(): void {}
    public onTimeoutHome?(): void {}
    public onTimeoutGuest?(): void {}
}
